import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e758fa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "risk-report" }
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Risk Report", -1))
const _hoisted_4 = { class: "risk-report-row" }
const _hoisted_5 = { class: "is-size-6" }
const _hoisted_6 = { class: "risk-report-row" }
const _hoisted_7 = { class: "is-size-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrIcon = _resolveComponent("NrIcon")!
  const _component_nr_tag = _resolveComponent("nr-tag")!
  const _component_NrCard = _resolveComponent("NrCard")!
  const _component_NrBar = _resolveComponent("NrBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: "#risk-report-detail",
      class: "is-flex",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.toggleOpen && $options.toggleOpen(...args))),
      "aria-expanded": $data.isOpen.toString(),
      "aria-controls": "risk-report-detail"
    }, [
      _hoisted_3,
      _createVNode(_component_NrIcon, {
        name: $data.isOpen ? 'chevron-down' : 'chevron-up',
        class: "m-left-4 align-center"
      }, null, 8, ["name"])
    ], 8, _hoisted_2),
    _createElementVNode("div", {
      id: "risk-report-detail",
      class: _normalizeClass($data.isOpen ? '' : 'is-hidden')
    }, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.severityData, (item, index) => {
          return (_openBlock(), _createBlock(_component_NrCard, {
            key: `card-${index}-${item.value}`,
            class: "is-inline-flex"
          }, {
            default: _withCtx(() => [
              _createElementVNode("strong", _hoisted_5, _toDisplayString(item.label), 1),
              _createVNode(_component_nr_tag, {
                class: "card-tag",
                label: `${item.value.toLocaleString('en-US')}`,
                "tag-color": item.active_color,
                size: "normal",
                badge: true
              }, null, 8, ["label", "tag-color"])
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _createVNode(_component_NrBar, { values: $options.severityData }, null, 8, ["values"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.reviewStatusData, (item, index) => {
          return (_openBlock(), _createBlock(_component_NrCard, {
            key: `card-${index}-${item.value}`,
            class: "is-inline-flex"
          }, {
            default: _withCtx(() => [
              _createElementVNode("strong", _hoisted_7, _toDisplayString(item.label), 1),
              _createVNode(_component_nr_tag, {
                class: "card-tag",
                label: `${item.value.toLocaleString('en-US')}`,
                "tag-color": item.active_color,
                size: "normal",
                badge: true
              }, null, 8, ["label", "tag-color"])
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _createVNode(_component_NrBar, { values: $options.reviewStatusData }, null, 8, ["values"])
      ])
    ], 2)
  ]))
}